var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar",style:(_vm.avatarStyle)},[(_vm.imageUrl)?_c('img',{attrs:{"src":_vm.imageUrl,"alt":"avatar"}}):[(_vm.$slots.default)?_vm._t("default"):_c('span',[_vm._v(_vm._s(_vm.firstChar))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }